<template>
<zm-dialog
  :visible.sync="visible"
  class="comparison-dialog comparison-dialog--zoom-one"
  :class="[$context.is.modal ? 'opc-modal-dialog' : '', isDesktopExcludeModal ? 'comparison-dialog-one-desktop-responsive' : '']"
  aria-labelledby="zoomMeetingFullComparisonTableTitle"
  :show-close="!$context.is.modal"
  :before-close="beforeClose"
  @close="handleCancel">
  <template slot="title">
    <NavBack v-if="$context.is.modal" :backHandler="handleCancel" />
    <h1 v-if="$context.is.desktop" class="comparison-dialog__title" id="zoomMeetingFullComparisonTableTitle">
      {{ $t('marketing.new_pricing.full_plan') }}</h1>
  </template>
  <component :is="getPlanComparisonComponentName()" class="opc-plan-comparison"
             :class="[unlockBizLicenseCount?'':'opc-plan-lock-count-comparison']" appName='opc'
             :comparisonProps="comparisonProps" :colConfig="colConfig"
             :hideCloseComparisonChart="!$context.is.desktop"
             :defaultExpandRowKeys="unlockBizLicenseCount?[]:['coreFeatures']">
    <template v-slot:[buttonSlotName]="{ col }">
        <div v-if="$context.is.desktop" tabindex="-1" class="type-title">{{ col.title }}</div>
      <full-comparison-dialog-price v-if="!unlockBizLicenseCount"
                                    :isNotAvailable="col.btn?!!col.btn.isNotAvailable:false"
                                    :zoom-meeting-category="col.category" style="margin-top: -5px;margin-bottom: 8px" />
      <template v-if="!col.hideBtn">
        <i tabindex="-1" v-if="col.category === currentBaseCategory || col.selected" class="zm-icon-ok no-event-btn"
           :aria-label="col.title + ' Selected'"></i>
        <zm-tooltip v-else-if="col.btn && col.btn.disabledTips" :disabled="!col.btn.disabled">
        <p @click='onSubmitFormClick(col, $event)' slot="content" v-html="col.btn.disabledTips"/>
            <!-- if use div elements to wrap it, there are some problems with the display and hiding of tooltip on mobile. -->
            <!-- <div> -->
              <zm-button data-testid="checkout-button-151" :type="col.btn.type" round @click="col.btn.callback(col)" :disabled="col.btn.disabled" :aria-label="col.btn.ariaLabel">{{ col.btn.label }}</zm-button>
            <!-- </div> -->
          </zm-tooltip>
          <zm-button data-testid="checkout-button-152"  tabindex="-1" v-else-if="col.btn" :type="col.btn.type" round @click="col.btn.callback(col)" :disabled="col.btn.disabled" :aria-label="col.btn.ariaLabel">{{ col.btn.label }}</zm-button>
          <div v-else class="empty-btn" aria-hidden="true" />
        </template>
      </template>
  </component>
</zm-dialog>
</template>
<script type="text/jsx">
import { get } from 'lodash';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import NavBack from '@/components/nav-back.vue';
import {
  AUDIO_SUB_TYPES,
  INDUSTRIES,
  contactUsPath,
  planTypes,
  BASE_PLAN_SUB_TYPES,
} from '@/common/constants';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { ZOOM_MEETING_SUB_TYPES, isBizPlusContext, checkBizPlanIsPending, getTitleNameI18nKey } from '../common/utils';
import { ZoomMeetingComparisonDataMixins } from '@/components/full-comparison-table/comparison-data-mixins';
import { translateToEn, translation } from '@/plugins/i18n';
import { isEmptyVal } from '@/utils';
import { plansof } from '@/utils/chain';
import MeetingComparisonMixins from './meeting-comparison-mixins'
import {ONLINE_NOT_SUPPORT_BILLING_CYCLE} from "@/common/service/non-standard-billing-cycle-utils";
import {
  computedPbxAddonPlans,
  computedPbxCallingPlans,
  computedPbxFeaturePlans,
} from '@/common/service/computers/plans/pbx';
import Migration from '@/plans/ZOOM_MEETING/dialog/mixins/migration';
import FullComparisonDialogPrice from '@/plans/ZOOM_MEETING/dialog/components/full-comparison-dialog-price.vue';
import { isFromCampaignLink, isFromCancelCampaign } from '@/views/config/coupon/helper/utils';

const PRO2BIZ_ZONE_BUNDLE = 'pro2zone_bundle'; // meeting pro --> zoom one biz/zoom one biz plus
const BIZ2BIZ_ZONE_BUNDLE = 'biz2zone_bundle'; // meeting biz --> zoom one biz plus

const getDefaultStatusMap = () => {
  return {
    disabled: true,
    link: contactUsPath,
    disabledTips: translation('billing.error.can_not_bought_plan_tips'),
  }
}

export default {
  name: 'FullComparisonDialog',
  mixins: [ConfirmComponent, ZoomMeetingComparisonDataMixins, MeetingComparisonMixins, Migration],
  components: {
    FullComparisonDialogPrice,
    NavBack,
  },
  props: {
    largeMeetingConfig: {
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
      allPlanMap: state => state.ShoppingCart.allPlanMap
    }),
    ...mapGetters([
      'getCurrentBasePlanInfo',
      'getSelectedPlans',
      'getBoughtBasePlanInfo',
      'basicConfig',
      'boughtPlans',
      'boughtPlansGroupByCategoryCode',
      'canUpgradeZoneBundle',
      'partnerRefer',
      'freeTrialPlans',
      'limitLicenseWithBaseZoneTypes',
      'plansofBizBundle',
      'currentEditPlan',
      'migratePlanState',
      'plancodeMapSubscriptionDisabled',
      'getTypeGroupSelectedPlans',
      'forNewSubscriptionFlow',
      'healthcareAvailable',
      'supportCouponCode'
    ]),
    unlockBizLicenseCount() {
      return get(window, 'campaignFlags.enableUnlockBizLicenseCountTempSafe', false);
    },
    disabledSelectedBtn4Partner() {
      // hard code for switch to other plan with partner
      // 1. from partner referral link
      // 2. for paid account to paid flow(edit, mix_buy, add etc)
      if (!isEmptyVal(this.partnerRefer) && !this.forNewSubscriptionFlow) {
        return true;
      }

      return false;
    },
    enableProPlusOnlineBuy() {
      return get(window, 'campaignFlags.enableProPlus', false);
    },
    buttonSlotName() {
      return this.$context.is.desktop ? 'comparison-table-header' : 'button';
    },
    haveZoomUnited() {
      return !!this.boughtPlans.find(item => item.type === planTypes.ZOOM_UNITED);
    },
    haveZoneProPlus() {
      return !!this.boughtPlans.find(p => p.type === planTypes.ZONE_PRO_PLUS);
    },
    canBuyBizPlus() {
      const disablePlanCategoryList = get(this.allPlanMap, 'disablePlanCategoryList', []);
      return !!get(this.allPlanMap, 'zoomone.zoom-one-biz-plus', '') && !disablePlanCategoryList.includes('ZONEBIZP');
    },
    canBuyProPlus() {
      const disablePlanCategoryList = get(this.allPlanMap, 'disablePlanCategoryList', []);
      return !!get(this.allPlanMap, 'zoomone.zoom-one-pro-plus', '') && !disablePlanCategoryList.includes('ZONEPROP');
    },
    colConfig() {
      const checkIsSelected = (val) => this.currentBaseCategory === val;

      const configList = [
        {
          title: this.$t('common.pro'),
          key: 'pro',
          category: ZOOM_MEETING_SUB_TYPES.PRO,
          visible: true,
          isSelected: checkIsSelected(ZOOM_MEETING_SUB_TYPES.PRO),
          btn: {
            label: this.$t('billing.common.select'),
            type: 'primary',
            ariaLabel: 'Select Pro',
            ...this.configProBtnStatus,
            callback: this.handleSwitchMeetingPlan.bind(this),
          },
        },
        {
          title: this.$t('billing.zone_pro_plus.brief_title'),
          category: ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS,
          key: 'proPlus',
          visible: this.configProPlusVisible,
          selected: plansof(this.getSelectedPlans).type(planTypes.ZONE_PRO_PLUS).has(),
          isSelected: checkIsSelected(ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS),
          btn: {
            label: this.$t('billing.common.select'),
            ariaLabel: 'Select Pro Plus',
            type: 'primary',
            ...this.configProPlusBtnStatus,
            callback: this.handleSwitchMeetingPlan.bind(this),
          },
        },
        {
          title: this.$t('common.business'),
          category: ZOOM_MEETING_SUB_TYPES.BIZ,
          key: 'business',
          visible: true,
          selected: plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).category(ZOOM_MEETING_SUB_TYPES.BIZ).has(),
          isSelected: checkIsSelected(ZOOM_MEETING_SUB_TYPES.BIZ),
          btn: {
            label: this.$t('billing.common.select'),
            ariaLabel: 'Select Business',
            type: 'primary',
            ...this.configBizBtnStatus,
            callback: this.handleSwitchMeetingPlan.bind(this),
          },
        },
        {
          title: this.$t('one.bizPlus'),
          category: ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS,
          key: 'businessPlus',
          visible: true,
          selected: plansof(this.getSelectedPlans).type(planTypes.ZOOM_ONE_BUNDLE).has(),
          isSelected: checkIsSelected(ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS),
          btn: {
            label: this.$t('billing.common.select'),
            ariaLabel: 'Select Business Plus',
            type: 'primary',
            ...this.configBizPlusBtnStatus,
            callback: this.handleSwitchMeetingPlan.bind(this),
          },
        },
      ];

      return configList.filter((p) => p.visible);
    },
    configProPlusVisible() {
      if (!this.enableProPlusOnlineBuy) {
        return false;
      }

      return true;
    },
    currentBaseCategory() {
      if (this.migratePlanState.is.bizplus2proplus) return ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS
      if (this.migratePlanState.is.pro2prop) return ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS;
      // biz plus to biz
      if (isBizPlusContext && !this.migratePlanState.is.bundle2biz) return ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS;
      const { planType, plans } = this.getCurrentBasePlanInfo;
      if(planType !== planTypes.ZOOM_MEETING || !plans[0]) {
        return '';
      }

      return get(plans, '0.zoomMeetingCategory', '');
    },
    boughtBaseCategory() {
      const { plans = [] } = this.getBoughtBasePlanInfo;
      return get(plans, '0.zoomMeetingCategory', '');
    },
    isBulkLicenseAccountBase() {
      return this.basicConfig?.isBulkLicenseAccount && this.getBoughtBasePlanInfo?.planType === planTypes.ZOOM_MEETING;
    },
    hasUnupportBillingCyclePlan() {
      const { plans = [] } = this.getBoughtBasePlanInfo;
      return ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(get(plans.filter(p => p.type === planTypes.ZOOM_MEETING), '0.billing_cycle', ''));
    },
    bizCanDowngrade() {
      // edit flow and current edit business plan
      if (flowTypes.edit === this.$context.flow
        && [ZOOM_MEETING_SUB_TYPES.BIZ, ZOOM_MEETING_SUB_TYPES.BIZ_INR].includes(this.boughtBaseCategory)
      ) {
        // bought unlimited audio plan
        const isBoughtUnlimitedAudio = Object.keys(this.boughtPlansGroupByCategoryCode).some((category) => {
          return [AUDIO_SUB_TYPES.UNLIMITED, AUDIO_SUB_TYPES.UNLIMITED].includes(category);
        });

        // have bought zoom one biz plus plan
        const boughtZoneBundlePlans = this.boughtPlans?.filter((plan) => plan?.type === planTypes.ZOOM_ONE_BUNDLE);

        // have bought zoom one biz plus free trial plan
        const boughtZoneBundleFtPlans = this.freeTrialPlans?.filter((plan) => plan?.type === planTypes.ZOOM_ONE_BUNDLE);

        // is allow downSell
        const disableDownSell = this.basicConfig?.downSellData?.disableDownSell;

        return (
          !boughtZoneBundlePlans?.length &&
          !boughtZoneBundleFtPlans?.length &&
          !isBoughtUnlimitedAudio &&
          !disableDownSell &&
          !this.isBulkLicenseAccountBase
        );
      }

      return false;
    },
    isMultipleRatePlans() {
      if ([flowTypes.edit].includes(this.$context.flow)) {
        const { plans = [] } = this.getBoughtBasePlanInfo;
        return plans.some(p => p.ratePlans?.length > 1);
      }
      return false;
    },
    configBtnDisabled4SupportCouponDowngrade() {
      if ([flowTypes.edit].includes(this.$context.flow)) {
        const isBizPlus = this.currentEditPlan?.type === planTypes.ZOOM_ONE_BUNDLE;
        const supportCoupon = this.supportCouponCode;
        return supportCoupon && isBizPlus;
      }

      return false;
    },
    configBtnDisabled4CouponCase() {
      // for cancellation campaign link promotion & the current edit plan have been cancelled
      if (isFromCancelCampaign() && isFromCampaignLink() && this.currentEditPlan?.cancelled === 1) {
        return true;
      }

      return false;
    },
    configProBtnStatus() {
      const flowType = this.$context.flow;
      const defaultStatusMap = getDefaultStatusMap();

      if (this.configBtnDisabled4CouponCase) {
        return defaultStatusMap;
      }

      if (this.disabledSelectedBtn4Partner) {
        return defaultStatusMap;
      }

      if (this.haveZoneProPlus) {
        return defaultStatusMap;
      }

      if (this.configBtnDisabled4SupportCouponDowngrade) {
        return defaultStatusMap;
      }

      if (this.$context.is.isFreeWinback) {
        return {
          disabled: true,
          link: '/'
        }
      }

      if(this.haveZoomUnited) {
        return {
          disabled: true,
          link: '/',
        }
      }

      if (this.isMultipleRatePlans) {
        return {
          disabled: true,
          link: '/',
        };
      }

      if ([flowTypes.basic2pro, flowTypes.buyNow, flowTypes.upgrade, flowTypes.trial2paid].includes(flowType)) {
        return {
          disabled: false,
          link: '/'
        }
      }

      if ([flowTypes.add2cart].includes(flowType) && this.basicConfig?.bizCanDowngrade) {
         // if no meeting plan which means purchased standalone product as paid account
         // and no biz+ plan
        if (!this.meetingPlans.length && !this.plansofBizBundle.boughtBizPlusPlan.length) {
          return {
            disabled: false,
            link: `/opc/buy?plan=z1s&subPlan=newsubs&from_sub=pro&type=add&majorPlanHost=1`
          }
        }
        // for biz plus
        if (isBizPlusContext) {
          return defaultStatusMap;
        }
        if (this.basicConfig?.bizCanDowngrade) {
          return {
            disabled: false,
            link: '/'
          };
        }
      }

      // MIX_BUY
      if ([flowTypes.edit, flowTypes.pro2biz, flowTypes.mixBuy].includes(flowType)) {
        const boughtBaseCategory = this.boughtBaseCategory;

        // for edit pro or biz can downgrade to pro
        if (boughtBaseCategory === ZOOM_MEETING_SUB_TYPES.PRO ||
          (boughtBaseCategory === ZOOM_MEETING_SUB_TYPES.BIZ && this.bizCanDowngrade)
        ) {
          return {
            disabled: false,
            link: '/'
          };
        }
      }

      return defaultStatusMap;
    },
    configBizBtnStatus() {
      const defaultStatusMap = getDefaultStatusMap();
      const flowType = this.$context.flow;

      if (this.configBtnDisabled4CouponCase) {
        return defaultStatusMap;
      }

      if (this.disabledSelectedBtn4Partner) {
        return defaultStatusMap;
      }

      if (this.configBtnDisabled4SupportCouponDowngrade) {
        return defaultStatusMap;
      }

      if (this.$context.is.isFreeWinback) {
        return {
          disabled: true,
          link: '/'
        }
      }

      // for biz plus
      if ([flowTypes.add2cart].includes(flowType)) {
        // if no meeting plan which means purchased standalone product as paid account
        if (!this.meetingPlans.length) {
          return {
            disabled: false,
            link: `/opc/buy?plan=z1s&subPlan=newsubs&from_sub=biz&type=add&majorPlanHost=1`
          }
        }
        if (isBizPlusContext || this.boughtPlans.find(p => p.isSingleUseProFreeTrial)) {
          return defaultStatusMap;
        }
      }

      if ([flowTypes.basic2pro, flowTypes.buyNow, flowTypes.upgrade, flowTypes.trial2paid, flowTypes.add2cart].includes(flowType)) {
        return {
          disabled: false,
          link: '/'
        }
      }

      if ([flowTypes.edit].includes(flowType) && isBizPlusContext) {
        if (!this.basicConfig?.canSelectBiz) return defaultStatusMap;
        // biz+ downgrade to biz
        if (this.basicConfig?.downSellData?.disableDownSell) return defaultStatusMap;
        // if has zp add-on plans and no zp calling plans, can not downgrade
        if (!computedPbxCallingPlans(this.boughtPlans).length && (computedPbxAddonPlans(this.boughtPlans).length || computedPbxFeaturePlans(this.boughtPlans).length)) return defaultStatusMap;
        // if has pending plan, don't allow downgrade to biz
        const { boughtBizPlan, hasFreeTrial } = this.plansofBizBundle;
        // check if has pending activation/downgrade biz plan
        let hasPendingBizPlan = checkBizPlanIsPending();
        if (hasPendingBizPlan) return defaultStatusMap;
        // check if contains op free trial plan
        if (hasFreeTrial) return defaultStatusMap;
        if (boughtBizPlan.length === 0) {
          return {
            disabled: false,
            link: '/'
          }
        }
        return defaultStatusMap;
      }

      // MIX_BUY
      if ([flowTypes.edit, flowTypes.pro2biz, flowTypes.mixBuy].includes(flowType)) {
        const boughtBaseCategory = this.boughtBaseCategory;
        const canSelectBiz = this.basicConfig?.canSelectBiz;

        // for pro2biz flow or edit business plan
        if ((boughtBaseCategory === ZOOM_MEETING_SUB_TYPES.PRO && canSelectBiz)
          || boughtBaseCategory === ZOOM_MEETING_SUB_TYPES.BIZ) {
          return {
            disabled: false,
            link: '/'
          }
        }
      }

      return defaultStatusMap;
    },
    configProPlusBtnStatus() {
      const flowType = this.$context.flow;
      const defaultStatusMap = getDefaultStatusMap();

      if (this.configBtnDisabled4CouponCase) {
        return defaultStatusMap;
      }

      if (this.configBtnDisabled4SupportCouponDowngrade) {
        return defaultStatusMap;
      }

      if (pageConfig.isFreeTrialAccount) {
        return defaultStatusMap;
      }

      // control currency + country
      if (!this.canBuyProPlus) {
        return { ...defaultStatusMap, isNotAvailable: true };
      }

      if (this.disabledSelectedBtn4Partner) {
        return defaultStatusMap;
      }


      if (this.$context.is.isFreeWinback) {
        return {
          disabled: true,
          link: '/'
        }
      }

      // control account
       if (!this.basicConfig?.canSelectProPlus) {
         if (this.migratePlanState.is.prop2bundle) {
           return {
             disabled: false,
             link: '/',
           };
         }
        return defaultStatusMap;
      }

      if ([flowTypes.basic2pro, flowTypes.buyNow].includes(flowType)) {
        return {
          disabled: false,
          link: `/opc/buy?plan=zoneproplus&from=zoneproplus_zonepropzvu&period=annual&type=${flowType}`,
        }
      }

      // flowTypes.trial2paid not support yet {adam, debbie}
      if ([flowTypes.add2cart].includes(flowType)) {
        if (isBizPlusContext && this.boughtBaseCategory === BASE_PLAN_SUB_TYPES.BIZ) return defaultStatusMap;
        if (this.plansofBizBundle.boughtBizPlusPlan.length) {
          return defaultStatusMap;
        }
        return {
          disabled: false,
          link: `/opc/buy?plan=z1s&subPlan=newsubs&from=zoneproplus&type=add`,
        }
      }

      if ([flowTypes.edit].includes(flowType)) {
        if (
          [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS, ZOOM_MEETING_SUB_TYPES.BIZ].includes(this.boughtBaseCategory) &&
          this.basicConfig?.downSellData?.disableDownSell
        ) {
          return defaultStatusMap
        }

        return {
          disabled: false,
          link: `/`,
        }
      }

      return defaultStatusMap;
    },
    configBizPlusBtnStatus() {
      const flowType = this.$context.flow;
      const defaultStatusMap = getDefaultStatusMap();

      if (this.configBtnDisabled4CouponCase) {
        return defaultStatusMap;
      }

      if (pageConfig.isFreeTrialAccount) {
        return defaultStatusMap;
      }

      // not allow to purchase zoom one biz plus
      if (!this.canBuyBizPlus) {
        return { ...defaultStatusMap, isNotAvailable: true };
      }


      if (this.disabledSelectedBtn4Partner) {
        return defaultStatusMap;
      }

      if (this.$context.is.isFreeWinback) {
        return {
          disabled: true,
          link: '/'
        }
      }

      // const from = getPlanTypeByCategory($query?.from) !== planTypes.ZOOM_MEETING && $query?.from || 'zonebundle_zonebizpzau';

      if (flowTypes.add2cart === flowType) {
        // if no meeting plan which means purchased standalone product as paid account
        if (!this.meetingPlans.length) {
          return {
            disabled: false,
            link: `/opc/buy?plan=z1s&subPlan=newsubs&from_sub=zonebundle&type=add&majorPlanHost=0`
          }
        }
      }

      if (flowTypes.buyNow === flowType) {
        return {
          disabled: false,
          link: `/opc/buy?plan=zonebundle&from=zonebundle_zonebizpzvu&period=annual`,
          // link: `/opc/buy?plan=zonebundle&from=${from}&period=annual`,
        }
      }

      if (flowTypes.basic2pro === flowType) {
        return {
          disabled: false,
          link: `/opc/buy?plan=zonebundle&subPlan=allSubPlan&type=basic2pro&from=zonebundle_zonebizpzvu&period=annual`,
        }
      }

      if (flowTypes.upgrade === flowType) {
        return defaultStatusMap;
      }

      if (flowTypes.edit === flowType && this.migratePlanState.is.downgrade) {
        return {
          disabled: false,
          link: '/'
        }
      }

      if (flowTypes.edit === flowType && this.canUpgradeZoneBundle) {
        const plan = this.boughtBaseCategory || ZOOM_MEETING_SUB_TYPES.PRO;
        const upgradeZoneMapping = { pro: PRO2BIZ_ZONE_BUNDLE, biz: BIZ2BIZ_ZONE_BUNDLE, education: BIZ2BIZ_ZONE_BUNDLE };

        if (plan === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS) {
          return {
            disabled: false,
            link: '/',
          }
        }

        return {
          disabled: false,
          link: `/account/billing/buy?plan=${plan}&subPlan=none&type=${upgradeZoneMapping[plan]}`,
        }
      }

      return defaultStatusMap;
    },
    meetingPlans() {
      return plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).get();
    },
    isHealthcareHost() {
      return this.healthcareAvailable && this.currentBaseCategory === ZOOM_MEETING_SUB_TYPES.PRO
    },
    // OBT-5972
    isDesktopExcludeModal() {
      return this.$context.is.desktop && !this.$context.is.modal;
    },
  },
  methods: {
    ...mapActions(['switchCategoryAction']),
    ...mapMutations(['removePlan', 'updateSelectPlan', 'setMigratePlanState']),
    getPlanComparisonComponentName() {
      return this.$context.is.modal ?
        'PlanComparisonMobile' :
        this.$context.is.desktop ?
          'PlanComparison' :
          'PlanComparisonMobile'
    },
    handleRowClick(row) {
      if (row.subTitle) {
        const featureCol = document.querySelector(`.${row.id}-sub-title`);
        let cel = null;
        let expandBtn = null;
        if (featureCol) {
          cel = featureCol.parentElement;
        }
        if (cel) {
          expandBtn = cel.querySelector('.zm-table__expand-icon');
        }
        if (expandBtn) {
          expandBtn.click();
        }
      }
    },
    arraySpanMethod({ row, columnIndex }) {
      if (row.subTitle) {
        return columnIndex === 0 ? [1, 10] : [0, 0];
      }
    },
    beforeClose(close) {
      if (this.isHealthcareHost) {
        const trackingPlanName = translateToEn(getTitleNameI18nKey(this.currentBaseCategory))
        this.$tracking.buyInteraction('product details', `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} full plan comparison - exit`)
      }

      close()
    },
  },
}
</script>
<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

$topMargin: 7vh;

.comparison-dialog {
  &.comparison-dialog--zoom-one {
    // override global style in nav-top-assets css in modal dialog
    &.opc-modal-dialog {
      .zm-dialog {
        width: 100% !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        height: 100% !important;
        max-width: 100%;
        border-radius: 0;
        @include media(tablet) {
          padding: 32px !important;
        }
        .comparison-tree-table-mobile__inside,
        .zm-dialog__body  {
          scrollbar-width: none;
          &::-webkit-scrollbar {
            display: none;
          }
        }
        .zm-dialog__body {
          .mb24 {
            margin-bottom: 24px;
          }
        }
        .zm-dialog__header {
          padding: 0;
          margin-bottom: 8px;
          .zm-dialog__headerbtn {
            position: absolute;
            top: 16px;
            right: 16px;
          }
        }
      }

    }
    .zm-dialog {
      width: 70%;
      padding-bottom: 0; // no padding bottom on desktop/mobile
      margin-top: $topMargin !important;
      margin-bottom: 0 !important;
      // modal has responsive height on mobile with margin top/bottom excluded
      @include media(mobile) {
        height: calc(100% - #{$topMargin} * 2) !important;
      }
      @include media(tablet) {
        height: calc(100% - #{$topMargin} * 2) !important;
      }
      @include media(mobile, tablet) {
        $dialogWidth: calc(100% - 24px);
        width: $dialogWidth !important;
        min-width: $dialogWidth !important;
        padding-bottom: 0 !important; // no padding bottom on desktop/mobile
        display: flex;
        flex-direction: column;
        align-items: stretch;
        &__header {
          flex-shrink: 0;
          width: 100%;
        }
        &__body {
          flex-grow: 1;
          width: 100%;
          overflow: hidden;
        }
      }
      @media screen and (min-width: 2200px) {
        width: 65%;
      }
    }
  }

  &__title {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 150%;
    color: #00053D;
    text-align: center;
  }

  .opc-plan-comparison {
    .button-area {
      box-sizing: content-box;
      padding-top: 12px;
      height: 38px;
    }
  }

  .opc-plan-lock-count-comparison {
    .comparison-tree-table-mobile__header-selection-row__col {
      .zm-select {
        border-bottom: 1px solid #E0E0E6 !important;
      }

    }

    .comparison-tree-table-mobile__header-left-col, .comparison-tree-table-mobile__header-right-col {
      .button-area {
        box-sizing: content-box;
        padding-top: 12px;
        min-height: 38px;
        height: auto;
        display: flex;
        flex-wrap: wrap;

      }

      .button-area > div:first-child {
        flex: 0 0 100%;
      }
    }
  }

  &.comparison-dialog-one-desktop-responsive {
    // responsive - start, modal has max height on desktop, center in vertical and horizontal
    display: flex;
    .zm-dialog {
      max-width: none;
      min-width: 980px;
      margin-top: auto !important; // center in vertical
      margin-bottom: auto !important; // center in vertical
      // window resize will trigger breakpoints
      @include media(mobile, tablet) {
        height: auto !important;
      }
    }
    .comparison-table-new {
      // dialog paddingTop(24) + dialog title(49)
      height: calc(100vh - #{$topMargin} * 2 - 49px - 24px) !important;
      max-height: 800px !important;
    }
    .zm-scrollbar__wrap {
      // dialog paddingTop(24) + dialog title(49) + plan header (120)
      height: calc(100vh - #{$topMargin} * 2 - 49px - 24px - 120px) !important;
      max-height: calc(800px - 120px) !important;
      margin-right: 0 !important; // no padding bottom on desktop
      margin-bottom: 0 !important; // no padding bottom on desktop
      &::-webkit-scrollbar { // no padding bottom on desktop
        width: 0;
        height: 0;
      }
    }
    @media screen and (max-width: 1690px) {
      .zm-scrollbar__wrap {
        // dialog paddingTop(24) + dialog title(49) + plan header (138)
        height: calc(100vh - #{$topMargin} * 2 - 49px - 24px - 138px) !important;
        max-height: calc(800px - 138px) !important;
      }
    }
    // responsive - end

    .comparison-container  {
      padding-bottom: 0; // no padding bottom on desktop
    }
    .button-icon {
      padding-left: 4px; // desktop only, since mobile already exits
    }
    .comparison-table-new td .cell {
      padding: 0 8px;
    }
    .is-hidden .cell {
      width: 180px; // width is same as the value set in common component
    }
  }
}


.zm-table th a {
  color: #0e71eb !important;
}

.zm-table--striped .zm-table__body tr.zm-table__row--striped td {
    background: #fff !important;
}

.zm-table__body tr.hover-row.zm-table__row--striped>td, .zm-table__body tr.hover-row>td {
    background-color: #f2f2f7 !important;
}

.opc-comparison-table th a {
    color: #0e71eb !important;
    font-weight: 400;
    text-decoration: none;
}

.zm-table.comparison-table-new{

  .zm-table--striped .zm-table__body tr.zm-table__row--striped td {
    background: #fff;
  }

   .zm-table__body tbody td {
    border-bottom: 1px solid #eaeaf0;
    border-radius: 0;
}

  .feature-col {
    text-align: left;
    font-family: Almaden Sans;
    font-style: normal;
    font-weight: 450;
    font-size: 16px;
    line-height: 150%;
    color: #00053d;
    padding: 20px 0;
}
  .type-title{
    color: #00053D;
  }
  .button-icon{
    background-color: transparent;
    border: none;
    font-size: 14px;
    line-height: 14px;
  }
   .feature-content.sub-title {
    font-family: Almaden Sans;
  }
}

.opc-comparison-table {
  .table-feature-title{
    margin-right: 4px;
  }
}

.opc-meeting-switch-plan-for-healthcare-confirm {
  $padding-horizontal: 32px;
  &.zm-message-box {
    padding: 32px 0 0;
  }
  .zm-message-box {
    &__header {
      padding: 0 $padding-horizontal;
    }
    &__content {
      margin-top: 16px;
      padding: 0 $padding-horizontal;
      line-height: 1.2;
      font-size: 16px;
      font-weight: 400;
      font-style: normal;
      color: #00053d;
    }
    &__btns {
      margin-top: 32px;
      padding: 24px $padding-horizontal;
      border-top: 1px solid #e0e0e6;
    }
  }
}
</style>
